import React from "react";

const CustomerTable = () => {
    const customers = [
        {
            "id": 14482,
            "name": "Megan Kaufman",
            "email": "hayesrebecca@example.com",
            "company": "Perez Group",
            "address": "455 James Mission Apt. 277, Wrighthaven, PA 99847",
            "value": "Low Value Customer"
        },
        {
            "id": 12684,
            "name": "Charles Martin",
            "email": "hubbardgina@example.org",
            "company": "Hoffman, West and Washington",
            "address": "1589 Williams Groves Suite 917, Walkerport, VI 39303",
            "value": "Low Value Customer"
        },
        {
            "id": 12726,
            "name": "George Howard",
            "email": "xwood@example.com",
            "company": "Humphrey-Salinas",
            "address": "318 Herrera Club, Jasonchester, NM 10835",
            "value": "Low Value Customer"
        },
        {
            "id": 13509,
            "name": "Margaret Cox",
            "email": "jellis@example.com",
            "company": "Finley-Curry",
            "address": "40945 Cannon Circle Suite 364, East Laurabury, MO 51239",
            "value": "Low Value Customer"
        },
        {
            "id": 17238,
            "name": "David Richardson",
            "email": "rebecca92@example.org",
            "company": "Taylor-Sullivan",
            "address": "63052 Erica Fords, Smithville, PA 99620",
            "value": "Low Value Customer"
        },
        {
            "id": 17416,
            "name": "Patrick Allen",
            "email": "amy59@example.com",
            "company": "Weaver PLC",
            "address": "2562 Jordan Village Apt. 174, Masonton, ME 87721",
            "value": "Low Value Customer"
        },
        {
            "id": 14626,
            "name": "Karen Caldwell",
            "email": "hunterburgess@example.net",
            "company": "Jackson-Alvarez",
            "address": "5249 Charles Walks Apt. 878, Walkerburgh, TX 97785",
            "value": "Low Value Customer"
        },
        {
            "id": 18237,
            "name": "Scott Phillips Jr.",
            "email": "collin32@example.org",
            "company": "Weeks LLC",
            "address": "PSC 0293, Box 2814, APO AP 15158",
            "value": "Low Value Customer"
        },
        {
            "id": 17419,
            "name": "William Brooks",
            "email": "michael74@example.com",
            "company": "Young-Castro",
            "address": "827 Michael Green Suite 598, Port Jameschester, MS 23660",
            "value": "Low Value Customer"
        },
        {
            "id": 14950,
            "name": "Christian Howard",
            "email": "hroberts@example.net",
            "company": "Zamora, Bennett and Taylor",
            "address": "006 White Lodge, Danielland, FM 26962",
            "value": "Low Value Customer"
        },
        {
            "id": 17716,
            "name": "Christy Walker",
            "email": "rvega@example.org",
            "company": "Taylor, Walker and Smith",
            "address": "9424 Elizabeth Falls Apt. 030, Chapmanton, KS 21309",
            "value": "High Value Customer"
        },
        {
            "id": 12415,
            "name": "Taylor Price",
            "email": "hornchristopher@example.com",
            "company": "Duncan, Mann and Ramsey",
            "address": "6644 Michael Crescent, North Joshua, WA 10905",
            "value": "High Value Customer"
        },
        {
            "id": 16985,
            "name": "Douglas Cisneros",
            "email": "michael62@example.net",
            "company": "Jackson-Peterson",
            "address": "1229 Rebecca Overpass, Karamouth, TN 16693",
            "value": "High Value Customer"
        },
        {
            "id": 13975,
            "name": "Joseph Robertson",
            "email": "watsonlinda@example.org",
            "company": "Espinoza, Jones and Kelly",
            "address": "5046 Burnett Forest, Bryantfurt, MP 72527",
            "value": "High Value Customer"
        },
        {
            "id": 13066,
            "name": "Miss Alexis Singh DVM",
            "email": "bmoody@example.net",
            "company": "Logan, Perez and Johnson",
            "address": "8756 Sara Lodge Apt. 060, Lake David, ND 14474",
            "value": "High Value Customer"
        },
        {
            "id": 18123,
            "name": "Madison Myers",
            "email": "brandonflynn@example.org",
            "company": "Maxwell Group",
            "address": "052 James Knoll Apt. 656, Nguyenview, DE 24018",
            "value": "High Value Customer"
        },
        {
            "id": 12931,
            "name": "Lauren Jones",
            "email": "brookscharles@example.org",
            "company": "Johnson, Johnson and Price",
            "address": "9996 Miller Mill, Port Johnny, CO 19601",
            "value": "High Value Customer"
        },
        {
            "id": 13596,
            "name": "Robert Banks",
            "email": "ythomas@example.org",
            "company": "Lee-Sandoval",
            "address": "13300 Holloway Spur, East Rachelton, VT 23976",
            "value": "High Value Customer"
        },
        {
            "id": 12657,
            "name": "James Fernandez",
            "email": "guzmandarlene@example.com",
            "company": "Smith Group",
            "address": "Unit 7400 Box 2387, DPO AP 00582",
            "value": "High Value Customer"
        },
        {
            "id": 16767,
            "name": "Sarah Brown",
            "email": "alexander79@example.com",
            "company": "Gibson-Hunter",
            "address": "415 Morgan Row, Vickitown, FM 77141",
            "value": "High Value Customer"
        }
    ];


    return (
        <div className="max-w-7xl mx-auto px-4 py-6">
            <h1 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-4">Sample list of 20 customers</h1>

            <div className="bg-white dark:bg-gray-900 shadow-md rounded-xl overflow-x-auto border border-gray-200 dark:border-gray-700">
                <table className="min-w-full table-auto text-sm text-left text-gray-700 dark:text-gray-200">
                    <thead className="bg-gray-100 dark:bg-gray-800 text-xs uppercase text-gray-600 dark:text-gray-300">
                        <tr>
                            <th className="px-6 py-3">Customer ID</th>
                            <th className="px-6 py-3">Name</th>
                            <th className="px-6 py-3">Email</th>
                            <th className="px-6 py-3">Company</th>
                            <th className="px-6 py-3">Address</th>
                            <th className="px-6 py-3">Customer Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {customers.map((customer, index) => (
                            <tr
                                key={customer.id}
                                className={index % 2 === 0 ?
                                    "bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800"
                                    : "bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700"
                                }
                            >
                                <td className="px-6 py-4 whitespace-nowrap">{customer.id}</td>
                                <td className="px-6 py-4">{customer.name}</td>
                                <td className="px-6 py-4">{customer.email}</td>
                                <td className="px-6 py-4">{customer.company}</td>
                                <td className="px-6 py-4">{customer.address}</td>
                                <td
                                    className={`px-6 py-4 font-semibold ${customer.value.includes("High") ? "text-green-600" : "text-gray-500"
                                        }`}
                                >
                                    {customer.value}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CustomerTable;
